import React from 'react';
import { Box } from '@mui/material';
import { ErrorBoundary } from '@sentry/react';
import { QueryClient, QueryClientProvider } from 'react-query';
import * as Sentry from '@sentry/react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './i18n/i18n';
import { CookiesProvider } from 'react-cookie';
import ThemeContext from './context/ThemeContext';
import Maintenance from './Maintenance';
import { UIContextProvider } from './context/UIContext';
import Fallback from './components/Fallback';
import { UserContextProvider } from './context/UserContext';
import { ApiContextProvider } from './context/ApiContext';
import NavigationComponents from './components/NavigationComponents';
import MainContainer from './components/MainContainer';
import { getBaseDomain } from './helpers/helpers';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      staleTime: 0,
    },
  },
});

const baseDomain = getBaseDomain(window.location.href);
const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);
const App = () => {
  const maintenanceMode = process.env.REACT_APP_MAINTENANCE_ENABLED === 'true';

  return (
    <ErrorBoundary fallback={<Fallback />}>
      {!maintenanceMode ? (
        <CookiesProvider defaultSetOptions={{ domain: `.${baseDomain}` }}>
          <UIContextProvider>
            <ThemeContext>
              <QueryClientProvider client={queryClient}>
                <Router>
                  <SentryRoutes>
                    <Route path="/" element={null} />
                  </SentryRoutes>
                </Router>
                <ApiContextProvider>
                  <UserContextProvider>
                    <Router>
                      <Box
                        sx={{
                          display: 'flex',
                        }}
                      >
                        <ErrorBoundary
                          beforeCapture={(scope) => {
                            scope.setTag('location', 'TopAndSideNav');
                          }}
                          fallback={<Fallback />}
                        >
                          <NavigationComponents />
                        </ErrorBoundary>
                        <MainContainer />
                      </Box>
                    </Router>
                  </UserContextProvider>
                </ApiContextProvider>
              </QueryClientProvider>
            </ThemeContext>
          </UIContextProvider>
        </CookiesProvider>
      ) : (
        <Maintenance />
      )}
    </ErrorBoundary>
  );
};

export default App;
